// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-H":"H_shp2-detail-H__wrU21"};